import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import * as moment from 'moment';
import {Moment} from 'moment';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE,} from '@angular/material/core';
import {MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter,} from '@angular/material-moment-adapter';
import {UntypedFormControl} from '@angular/forms';
import {MatDatepicker} from '@angular/material/datepicker';
import {DateRange} from '../../core/models/date-range';
import {TextKeys} from '../../core/i18n/text-keys';
import {TIMEZONE} from '../../core/services/language.service';

// Register locale with Monday-first week (CH/EU norm) and 2-letter German month abbreviations.
// moment.defineLocale() sets the global locale as a side effect, so we restore it immediately.
moment.defineLocale('de-ch-adm', {
  months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
  monthsShort: 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
  // moment weekday arrays always start on Sunday (index 0)
  weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
  weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
  weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
  longDateFormat: {
    LT: 'HH:mm', LTS: 'HH:mm:ss',
    L: 'DD.MM.YYYY', LL: 'D. MMMM YYYY',
    LLL: 'D. MMMM YYYY HH:mm', LLLL: 'dddd, D. MMMM YYYY HH:mm',
  },
  week: { dow: 1, doy: 4 }, // Monday first, ISO week numbering
});
moment.locale('en'); // restore global locale

const MY_FORMATS = {
  parse: {
    dateInput: 'W/YYYY',
  },
  display: {
    dateInput: 'W/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-week-selection',
  templateUrl: './week-selection.component.html',
  styleUrls: ['./week-selection.component.scss'],
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },
    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
    {provide: MAT_DATE_LOCALE, useValue: 'de-ch-adm'},
    {provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: {useUtc: true}},
  ],
})
export class WeekSelectionComponent implements OnInit, OnDestroy {
  @Input() defaultDate: DateRange;
  @Output() weekSelectionChanged = new EventEmitter<DateRange>();

  date: UntypedFormControl;
  texts = TextKeys;

  constructor() {
  }

  ngOnInit() {
    if(this.defaultDate){
      this.date = new UntypedFormControl(moment.tz(this.defaultDate.end, TIMEZONE))
    }else{
      this.date = new UntypedFormControl(moment.tz(moment(), TIMEZONE))
    }
  }

  chosenYearHandler(normalizedYear: Moment) {
    const ctrlValue = this.date.value;
    ctrlValue.year(normalizedYear.year());
    this.date.setValue(ctrlValue);
    this.onChange();
  }

  chosenMonthHandler(
    normalizedMonth: Moment,
    datepicker: MatDatepicker<Moment>
  ) {
    const ctrlValue = this.date.value;
    ctrlValue.month(normalizedMonth.month());
    this.date.setValue(ctrlValue);
    this.onChange();
  }

  getDateRange(): DateRange {
    return {
      start: moment.tz(this.date.value, TIMEZONE).startOf('isoWeek').format(),
      end: moment.tz(this.date.value, TIMEZONE).endOf('isoWeek').format(),
    } as DateRange;
  }

  disable() {
    this.date.disable();
  }

  enable() {
    this.date.enable();
  }

  onChange(){
    console.log('week selection changed');
    this.weekSelectionChanged.emit(this.getDateRange());
  }

  previousWeek(event: Event) {
    event.stopImmediatePropagation();

    this.date.setValue(this.date.value.subtract(1, 'isoWeek'));
    this.onChange();
  }

  nextWeek(event: Event) {
    event.stopImmediatePropagation();
    this.date.setValue(this.date.value.add(1, 'isoWeek'));
    this.onChange();
  }

  ngOnDestroy(): void {
  }
}
